import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Tabs, Tab, Grid, CircularProgress} from '@material-ui/core'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import DocumentToSign from 'src/page/Consumer/Transactions/documents/tabs/DocumentToSign'
import DocumentSigned from 'src/page/Consumer/Transactions/documents/tabs/DocumentSigned'
import OtherDocument from 'src/page/Consumer/Transactions/documents/tabs/OtherDocument'
import { css } from 'src/conf/style'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import { DocumentCriteria } from 'src/type/criteria/documentCriteria'
import { RootState } from 'src/core/redux/reducer'
import { fetchDocToSign, fetchDocSigned, fetchOtherDoc } from 'src/core/redux/action/transactionsAction'
import { connect } from 'react-redux'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { ITransactionChange, ITransactionPlacement, ITransactionDette } from 'src/type/transaction'
import {get} from 'lodash'

const styles = (t: Theme) => createStyles({
    tabsRoot: {
        marginBottom: t.spacing.unit * 4,
        borderBottom: '1px solid #e8e8e8'
    },
    tabsIndicator: {
        backgroundColor: t.palette.primary.main
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: t.typography.fontWeightRegular,
        marginRight: t.spacing.unit * 4,
        '&:hover': {
            color: t.palette.primary.main,
            opacity: 1,
        },
        '&$tabSelected': {
            color: t.palette.primary.main,
            fontWeight: t.typography.fontWeightMedium,
        },
        '&:focus': {
            color: t.palette.primary.main,
        },
    },
    tabSelected: {

    },
    tabLbl: {
        ...css.flexFullCenter
    },
    badge: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: t.palette.primary.main,
        marginLeft: '.75rem',
        minWidth: '20px'
    },
    badge2: {
        borderRadius: '4px',
        color: t.palette.common.white,
        background: 'rgb(63,81,181)',
        marginLeft: '.75rem',
        minWidth: '20px'
    }
});

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithGlobalProgress,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
      transaction: ITransactionChange | ITransactionPlacement | ITransactionDette;
}

interface IStates {
    tabActive: number;
    isSignaturesLoaded: boolean;
    isDocToSignLoaded: boolean;
    isDocNotToSignLoaded: boolean;
}

class Documents extends React.Component<IProps, IStates> {
    state = {
        tabActive: 0,
        isSignaturesLoaded: false,
        isDocToSignLoaded: false,
        isDocNotToSignLoaded: false,
    };

  render(){
    const { t, classes, signaturesSize, docToSignSize, docNotToSignSize } = this.props;
    const { tabActive, isSignaturesLoaded, isDocToSignLoaded, isDocNotToSignLoaded } = this.state;
    return(
        <>
            {(!isSignaturesLoaded || !isDocToSignLoaded || !isDocNotToSignLoaded) &&
                <div className={classes.tabLbl}>
                    <CircularProgress size={32}/>
                </div>
            }
            {isSignaturesLoaded && isDocToSignLoaded && isDocNotToSignLoaded &&
                <Grid container>
                    <Grid item xs={12}>
                        <Tabs
                        value={tabActive}
                        onChange={this.handleChange}
                        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                        scrollable scrollButtons="off"
                        >
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label={
                                    <div className={classes.tabLbl}>
                                        Signatures
                                        <div className={classes.badge}>{docToSignSize}</div>
                                    </div>
                                }
                            />
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label={
                                    <div className={classes.tabLbl}>
                                        {t.document_signed}
                                        <div className={classes.badge2}>{signaturesSize}</div>
                                    </div>
                                }
                            />
                            <Tab
                                disableRipple
                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                label={
                                    <div className={classes.tabLbl}>
                                        {t.document_other}
                                        <div className={classes.badge2}>{docNotToSignSize}</div>
                                    </div>
                                }
                            />
                        </Tabs>

                        {this.tabContentRendering(tabActive)}
                    </Grid>
                </Grid>
            }
       </>
    )
  }

  @autobind
  private handleChange(event, value) {
    this.setState({ tabActive: value });
  };

  getContractNumber = (transaction: ITransactionChange | ITransactionPlacement | ITransactionDette) => get(transaction, "transaction.numero_du_contrat", "");

  signaturesLoaded = () => this.setState({isSignaturesLoaded: true})
  docToSignLoaded = () => this.setState({isDocToSignLoaded: true})
  docNotToSignLoaded = () => this.setState({isDocNotToSignLoaded: true})

  componentDidMount(){
    const {promisesWithProgress, criteriaDocToSign, criteriaDocNotToSign, transaction} = this.props
    const criteriaDocumentSigned = {tag: this.getContractNumber(transaction)}
    const criteriaSignatureAndOtherDoc = {target_type: "TRANSACTION", target_id: this.getContractNumber(transaction)}
    promisesWithProgress(
        this.props.fetchDocToSign({...criteriaDocToSign, ...criteriaSignatureAndOtherDoc}).then(docToSign => {
            if(docToSign && docToSign.total_size && docToSign.total_size > 0) {
                this.setState({tabActive: 0})
            } else {
                this.setState({tabActive: 1})
            }
            this.docToSignLoaded()
        }).catch(err => {this.docToSignLoaded()}),
        this.props.fetchDocSigned({...criteriaDocToSign, ...criteriaDocumentSigned}).then(res => {this.signaturesLoaded()}).catch(err => {this.signaturesLoaded()}),
        this.props.fetchOtherDoc({...criteriaDocNotToSign, ...criteriaSignatureAndOtherDoc}).then(res => {this.docNotToSignLoaded()}).catch(err => {this.docNotToSignLoaded()})
    )
  }


  private tabContentRendering(tabActive){
      const contractNumber = this.getContractNumber(this.props.transaction);
      switch(tabActive){
        case 0: 
            return <DocumentToSign {...{contractNumber}}/>
        case 1: 
            return <DocumentSigned {...{contractNumber}}/>
        case 2:
            return <OtherDocument {...{contractNumber}}/>
        default: 
            return '';
      }
  }
}

const state2props = (state: RootState) => ({
    criteriaDocToSign: state.paginate.docToSign.criteria,
    criteriaDocNotToSign: state.paginate.docNotToSign.criteria,
    signatures: state.paginate.signatures.entities,
    docToSign: state.paginate.docToSign.entities,
    docNotToSign: state.paginate.docNotToSign.entities,
    signaturesSize: state.paginate.signatures.total_size,
    docToSignSize: state.paginate.docToSign.total_size,
    docNotToSignSize: state.paginate.docNotToSign.total_size
});

const dispatch2props = dispatch => ({
    fetchDocToSign: (c: SignatureCriteria) => dispatch(fetchDocToSign(c)),
    fetchDocSigned: (c: SignatureCriteria) => dispatch(fetchDocSigned(c)),
    fetchOtherDoc: (c: DocumentCriteria) => dispatch(fetchOtherDoc(c)),
});


export default compose(
  withI18n,
  withGlobalProgress,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Documents)



// WEBPACK FOOTER //
// ./src/page/Consumer/Transactions/documents/Documents.tsx